var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "header-back" }, [
      _c("div", { on: { click: _vm.backList } }, [
        _c("em", {
          staticClass: "el-icon-arrow-left",
          staticStyle: { "font-size": "20px" },
        }),
        _vm._v(" "),
        _c("span", { staticClass: "header-back-txt" }, [
          _vm._v(_vm._s(_vm.$t("materialDetails.header.materialCode")) + ": "),
          _c("span", { attrs: { id: "link", readonly: "" } }, [
            _vm._v(_vm._s(_vm.form.materialCode)),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("em", {
        staticClass: "el-icon-copy-document btn",
        attrs: {
          "data-clipboard-": "",
          action: "copy",
          "data-clipboard-target": "#link",
        },
        on: { click: _vm.copyLink },
      }),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "action-container" },
      [
        _c(
          "el-form",
          { attrs: { size: "small", inline: "", "label-position": "top" } },
          [
            _c(
              "div",
              { staticClass: "container-item" },
              [
                _c(
                  "div",
                  { staticClass: "container-item-title" },
                  [
                    _c("span", [
                      _vm._v(_vm._s(_vm.$t("materialDetails.form.title"))),
                    ]),
                    _vm._v(" "),
                    _vm._l(
                      _vm.lookupList["PRODUCT_SAPOFFSHELF_STATUS"],
                      function (item) {
                        return _c("div", { key: item.code }, [
                          item.code == _vm.form.sapOffshelf
                            ? _c("span", [
                                _c(
                                  "div",
                                  {
                                    staticClass: "text-status ",
                                    class:
                                      _vm.form.sapOffshelf === "Y"
                                        ? "success"
                                        : "warning",
                                  },
                                  [_vm._v(" " + _vm._s(item.name))]
                                ),
                              ])
                            : _vm._e(),
                        ])
                      }
                    ),
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "el-row",
                  {
                    staticClass: "row-bg",
                    attrs: { type: "flex", justify: "space-between" },
                  },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "form-item-title",
                            attrs: {
                              label: _vm.$t(
                                "materialDetails.form.materialCode"
                              ),
                            },
                          },
                          [
                            _c("div", { staticClass: "item-txt" }, [
                              _c("span", [
                                _vm._v(_vm._s(_vm.form.materialCode)),
                              ]),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "form-item-title",
                            attrs: {
                              label: _vm.$t("materialDetails.form.language"),
                            },
                          },
                          [
                            _c("div", { staticClass: "item-txt" }, [
                              _c("span", [_vm._v(_vm._s(_vm.form.language))]),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "form-item-title",
                            attrs: {
                              label: _vm.$t(
                                "materialDetails.form.materialDescription"
                              ),
                            },
                          },
                          [
                            _c("div", { staticClass: "item-txt" }, [
                              _c("span", [
                                _vm._v(_vm._s(_vm.form.materialDescription)),
                              ]),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-row",
                  {
                    staticClass: "row-bg",
                    attrs: { type: "flex", justify: "space-between" },
                  },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "form-item-title",
                            attrs: {
                              label: _vm.$t("materialDetails.form.vehicleType"),
                            },
                          },
                          [_c("span", [_vm._v(_vm._s(_vm.form.vehicleType))])]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "form-item-title",
                            attrs: {
                              label: _vm.$t("materialDetails.form.rim"),
                            },
                          },
                          [_c("span", [_vm._v(_vm._s(_vm.form.rim))])]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "form-item-title",
                            attrs: {
                              label: _vm.$t("materialDetails.form.tyreSize"),
                            },
                          },
                          [_c("span", [_vm._v(_vm._s(_vm.form.tyreSize))])]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-row",
                  {
                    staticClass: "row-bg",
                    attrs: { type: "flex", justify: "space-between" },
                  },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "form-item-title",
                            attrs: {
                              label: _vm.$t("materialDetails.form.speedIndex"),
                            },
                          },
                          [_c("span", [_vm._v(_vm._s(_vm.form.speedIndex))])]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "form-item-title",
                            attrs: {
                              label: _vm.$t("materialDetails.form.loadIndex"),
                            },
                          },
                          [_c("span", [_vm._v(_vm._s(_vm.form.loadIndex))])]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "form-item-title",
                            attrs: {
                              label: _vm.$t("materialDetails.form.rofType"),
                            },
                          },
                          [_c("span", [_vm._v(_vm._s(_vm.form.rofType))])]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-row",
                  {
                    staticClass: "row-bg",
                    attrs: { type: "flex", justify: "space-between" },
                  },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "form-item-title",
                            attrs: {
                              label: _vm.$t("materialDetails.form.pattern"),
                            },
                          },
                          [_c("span", [_vm._v(_vm._s(_vm.form.pattern))])]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "form-item-title",
                            attrs: {
                              label: _vm.$t(
                                "materialDetails.form.countryOfOrigin"
                              ),
                            },
                          },
                          [
                            _c("span", [
                              _vm._v(_vm._s(_vm.form.countryOfOrigin)),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "form-item-title",
                            attrs: {
                              label: _vm.$t("materialDetails.form.oeMark"),
                            },
                          },
                          [_c("span", [_vm._v(_vm._s(_vm.form.oeMark))])]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-row",
                  {
                    staticClass: "row-bg",
                    attrs: { type: "flex", justify: "space-between" },
                  },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "form-item-title",
                            attrs: {
                              label: _vm.$t(
                                "materialDetails.form.englishPatName"
                              ),
                            },
                          },
                          [
                            _c("span", [
                              _vm._v(_vm._s(_vm.form.englishPatternName)),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "form-item-title",
                            attrs: {
                              label: _vm.$t("materialDetails.form.sapOffshelf"),
                            },
                          },
                          _vm._l(
                            _vm.lookupList["SAPOFFSHELF_STATUS"],
                            function (item) {
                              return _c("div", { key: item.code }, [
                                item.code == _vm.form.sapOffshelf
                                  ? _c("span", [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(item.name) +
                                          "\n                "
                                      ),
                                    ])
                                  : _vm._e(),
                              ])
                            }
                          ),
                          0
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "form-item-title",
                            attrs: {
                              label: _vm.$t("materialDetails.form.brand"),
                            },
                          },
                          [_c("span", [_vm._v(_vm._s(_vm.form.brand))])]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _c(
                      "el-form-item",
                      {
                        staticClass: "form-item-title",
                        staticStyle: { width: "100%" },
                        attrs: {
                          label: _vm.$t("materialDetails.form.fitment"),
                        },
                      },
                      [_c("span", [_vm._v(_vm._s(_vm.form.fitment))])]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }